export default {"src":"/_next/static/media/md-bubble-chart-slateus.8cc52384.svg","height":32,"width":32};